import { render, staticRenderFns } from "./SaveResumeDialog.vue?vue&type=template&id=2f88aad7&scoped=true"
import script from "./SaveResumeDialog.vue?vue&type=script&lang=js"
export * from "./SaveResumeDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveResumeDialog.vue?vue&type=style&index=0&id=2f88aad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88aad7",
  null
  
)

export default component.exports